<style lang="less" scoped>
.book-dopractice {
  background-color: #f1f0f0;
  display: flex;
  justify-content: center;
  align-items: center;
  .loading{
    position:absolute;
    top: 40%;
    left: 50%;
    transform: translate(50%,50%);
  }
}
.book-textreadguide-content {
  border-radius: @border-radius-base;
  background-color: @white;
  width: 1100px;
  margin-top: 30px;
  padding-top: 40px;
  padding-left: 50px;
  padding-bottom: 55px;
  padding-right: 50px;
  position: relative;
  .back-Btn {
    display: inline-block;
    justify-content: left;
    align-items: center;
    cursor: pointer;
    font-size: 20px;
    color: #dbd1cd;
    font-family: "PingFangSC-Semibold";
    height: 30px;
    .back-Icon {
      height: 19px;
      position: relative;
      right: 10px;
    }
  }
  .back-Btn:hover {
    color: @primary-color;
  }
  .submits {
    position:absolute;
    top: 50px;
    right: 50px;
    .sub_jilu {
      background-color: #5a99ef;
      color: @white;
    }
  }
  .content{
    padding:20px;
    white-space: pre-wrap;
    font-size: 20px;
    .item-title{
      color:#bdb6b4;
    }
    .quInfo{
      margin:1em 2em;
    }
    .articleTitle{
      text-align: center;
      font-size: 24px;
    }
    .article{
      margin: 15px 2em;
      line-height:1.6em;
    }
    .article u{
      color: @primary-color!important;
    }
    .left{
      text-align: left;
    }
    .right{
      text-align: right;
    }
    .center{
      text-align: center;
    }
    .study-test-stos{
      .tigan{
        font-weight: bold;
        margin-left:1em;
      }
      .input-box{
        margin-left:2em;
        margin-right:2em;
        margin-bottom:1em;
      }
    }
  }
}
.times {
  width: 100%;
  height: 40px;
  line-height: 43px;
  background-color: #ffffff;
  border-radius: 8px;
  border: solid 1px #dbd1cd;
  margin-bottom: 10px;
  padding: 0 20px;
  box-sizing: border-box;
  cursor: pointer;
  .colors {
    color: salmon;
    font-size: 20px;
  }
  .time_sj {
    float: left;
  }
  .time_data {
    float: left;
    margin-left: 20px;
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 40px;
    letter-spacing: 0px;
    color: #353b50;
  }
  .foot {
    float: right;
    color: salmon;
  }
}
.ant-radio-button-wrapper,.ant-checkbox-wrapper{
  position: static;
  width: 100%;
  font-size: 20px;
  background-color:#f5f9fe;
  border-radius: @border-radius-base!important;
  display:flex;
  margin: 5px;
  border:none;
  padding:5px 10px;
  height: auto;
}
.ant-radio-button-wrapper:hover{
  position: static;
}
.ant-radio-button-wrapper:first-child{
  border-left:none;
}
.ant-radio-button-wrapper:last-child {
  border-left:none;
}
.ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
  background: #6195d1;
  box-shadow:none;
}
.ant-radio-group-default, .ant-checkbox-group{
  width: 100%;
  padding-left:2.5em;
  padding-right:2.5em;
  margin-top: -10px;
  margin-bottom: 10px;
}
.ant-checkbox-wrapper{
  padding:5px 10px;
}
/deep/.ant-checkbox-inner{
  width:25px;
  height: 25px;
  top: 50%;
  transform: translate(0%,-50%)
}
/deep/.ant-checkbox-inner::after{
  width:10px;
  height: 14px;
}
/deep/.ant-checkbox-checked::after{
  border: none;
}
/deep/.ant-modal-header, /deep/.ant-modal-content {
  background-color: #f1f0f0;
  border-radius: @border-radius-base;
}
/deep/.ant-modal-close{
  color: @primary-color;
}
.ant-checkbox-wrapper:first-child{
  margin-left:8px;
}
.ant-radio-button-wrapper-checked.ant-radio-button-wrapper-disabled.wrong,
.ant-checkbox-wrapper-checked.ant-checkbox-wrapper-disabled.wrong
{
  background-color: red;
  .r{
    display:none;
  }
  .w{
    display:block;
  }
  .choose-item{
    color:white;
  }
}
.c, .w{
  display:none;
}
.ant-radio-button-wrapper-disabled.correct,
.ant-checkbox-wrapper-disabled.correct
{
  background-color: #06bc8c;
  .c{
    display:block;
  }
  .w{
    display:none;
  }
  .choose-item{
    color: white;
  }
}
.btn{
  width: 280px;
  height: 50px;
  border-radius: 30px;
  font-size: 24px;
  color: @white;
}
.green-btn{
  background-color: #06bc8c;
}
.orange-btn{
  background-color: #ff9a4a;
}
.green-txt{
  color: #06bc8c;
}
.orange-txt{
  color: #ff9a4a;
}
.record{
  border-radius: @border-radius-base;
  background-color: @white;
  margin: 20px;
  padding: 40px 30px;
}
.record-title{
  font-size: 20px;
  font-weight:bold;
  margin-left:1em;
}
.choose-item{
  display: flex;
  align-items: center;
}
.choose-item span{
  margin-right:1.5em;
}
.choose-item span:first-child{
  margin-right:1em;
  font-weight: bold;
}
// .choose-item span:last-child{
//   position:absolute;
//   right:70px;
// }
.analysis{
  margin:1em;
  text-align:right;
  span{
    display: inline-block;
    margin-left: 1em;
    cursor: pointer;
    font-size: 18px;
  }
  span:hover{
    color:@primary-color;
  }
  .analysis-content{
    font-size: 18px;
    text-align:left;
    background-color: #e6f8f3;
    border-radius: 4px;
    padding:1em;
  }
}
</style>

<template>
  <div class="book-dopractice">
    <div class="book-textreadguide-content">
      <div class="back-Btn"
           @click="goArticle()">
        <han-icon type="leftDobuleArrowIcon"
                  class="back-Icon" />
        <span>返回课文</span>
      </div>
      <div class="submits">
          <a-button class="sub_jilu" :loading="recordLoading" @click="getAnswerNotes()">答题记录</a-button>
          <a-button type="primary"
          :loading="submitLoading"
          :disabled="disabled"
          @click="showAnalysis?redoPractice():submitAnswer()">{{showAnalysis?"重做":"提交"}}</a-button>
      </div>
      <div class="content">
        <div v-for="(item,index) in exerciseList" :key="index">
          <p class="item-title" v-if="item.title!=''">{{item.quNum}}、{{item.title.trim()}}</p>
          <div v-if="item.articleTitle!=''" class="articleTitle">{{item.articleTitle}}</div>
          <div
            :class="{article:true,
            left:item.articleFormat===1,
            center:item.articleFormat===2,
            right:item.articleFormat===3
          }" v-html="item.readContent"></div>
          <div class="study-test-stos"
            v-for="(ite,inde) in item.studyTestDTOS"
            :key="inde">
            <p class="tigan" v-if="item.title!=''">{{item.studyTestDTOS.length>1?(inde+1)+'.':''}} {{ite.quTitle.trim()}}</p>
            <p class="item-title" v-if="item.title===''">{{item.quNum}}、{{ite.quTitle.trim()}}</p>
            <div v-if="ite.quInfo!=''" class="quInfo">{{ite.quInfo.trim()}}</div>
            <!-- ite.quType===1 填空题处理 -->
            <div v-if="ite.quType===1" >
              <div :class="{article:true,
                left:item.articleFormat===1,
                center:item.articleFormat===2,
                right:item.articleFormat===3
              }"><p v-for="(it,ind) in ite.testOptionDTOS" :key="ind">{{it.optionContent}}</p>
              </div>
              <div class="input-box">
                <a-input :disabled="showAnalysis" v-model="userAnswers[ite.curIndex]" placeholder="请输入答案，以豆号隔开" />
              </div>
              <div v-if="showAnalysis" class="analysis">
                <span class="green-txt"
                  @click="setShowSysAnswerContents(ite.curIndex)"
                >
                  参考答案
                </span>
                <span
                  @click="setShowAnalyContents(ite.curIndex)"
                  class="orange-txt"
                >
                  查看解析
                </span>
                <transition
                  enter-active-class="animated fadeIn"
                  leave-active-class="animated fadeOut"
                >
                <div class="analysis-content green-txt" v-show="showSysAnswersContents[ite.curIndex]"><h4>参考答案：</h4>{{ite.answer}}</div>
                </transition>
                <transition
                  enter-active-class="animated fadeIn"
                  leave-active-class="animated fadeOut"
                >
                <div class="analysis-content orange-txt" v-show="showAnalyContents[ite.curIndex]"><h4>解析：</h4>{{ite.quAnalyse}}</div>
                </transition>
              </div>
            </div>
            <!-- ite.quType===2 判断题 5 单项选择题 -->
            <a-radio-group
              button-style="solid"
              v-if="ite.quType===5||ite.quType===2"
              v-model="userAnswers[ite.curIndex]"
              :disabled="showAnalysis"
            >
              <a-radio-button v-for="(it,ind) in ite.testOptionDTOS"
                :value="it.optionContent.charAt(0)"
                :key="ind"
                :class="{
                  'correct':it.isRight,
                  'wrong':!it.isRight
                }"
              >
                <div class="choose-item">
                  <span>{{it.optionContent.charAt(0)}}</span>
                  <span>{{it.optionContent.substring(1, it.optionContent.length).trim()}}</span>
                  <span v-if="showAnalysis">
                    <a-icon class="c" type="check"/>
                    <a-icon class="w" type="close"/>
                  </span>
                </div>
              </a-radio-button>
              <div v-if="showAnalysis" class="analysis">
                <span
                  @click="setShowAnalyContents(ite.curIndex)"
                  class="orange-txt"
                >
                  查看解析
                </span>
                <transition
                  enter-active-class="animated fadeIn"
                  leave-active-class="animated fadeOut"
                >
                <div class="analysis-content orange-txt" v-show="showAnalyContents[ite.curIndex]"><h4>解析：</h4>{{ite.quAnalyse}}</div>
                </transition>
              </div>
            </a-radio-group>
            <!-- ite.quType===3 简答题 -->
            <div class="input-box" v-if="ite.quType===3">
              <a-textarea
                v-model="userAnswers[ite.curIndex]"
                placeholder="请输入答案！"
                :auto-size="{ minRows: 2, maxRows: 6 }"
                :disabled="showAnalysis"
              />
              <div v-if="showAnalysis" class="analysis">
                <span class="green-txt"
                  @click="setShowSysAnswerContents(ite.curIndex)"
                >
                  参考答案
                </span>
                <span
                  @click="setShowAnalyContents(ite.curIndex)"
                  class="orange-txt"
                >
                  查看解析
                </span>
                <transition
                  enter-active-class="animated fadeIn"
                  leave-active-class="animated fadeOut"
                >
                <div class="analysis-content green-txt" v-show="showSysAnswersContents[ite.curIndex]"><h4>参考答案：</h4>{{ite.answer}}</div>
                </transition>
                <transition
                  enter-active-class="animated fadeIn"
                  leave-active-class="animated fadeOut"
                >
                <div class="analysis-content orange-txt" v-show="showAnalyContents[ite.curIndex]"><h4>解析：</h4>{{ite.quAnalyse}}</div>
                </transition>
              </div>
            </div>
            <!-- ite.quType===6 多项选择题 -->
            <a-checkbox-group
              v-model="userAnswers[ite.curIndex]"
              v-if="ite.quType===6"
              :disabled="showAnalysis"
            >
              <a-checkbox v-for="(it,ind) in ite.testOptionDTOS"
                :value="it.optionContent.charAt(0)"
                :key="ind"
                :class="{
                  'correct':it.isRight,
                  'wrong':!it.isRight
                }"
                >
                <div class="choose-item">
                  <span>{{it.optionContent.charAt(0)}}</span>
                  <span>{{it.optionContent.substring(1, it.optionContent.length).trim()}}</span>
                  <span v-if="showAnalysis">
                    <a-icon class="c" type="check"/>
                    <a-icon class="w" type="close"/>
                  </span>
                </div>
              </a-checkbox>
              <div v-if="showAnalysis" class="analysis">
                <span class="orange-txt"
                @click="setShowAnalyContents(ite.curIndex)">查看解析</span>
                <transition
                  enter-active-class="animated fadeIn"
                  leave-active-class="animated fadeOut"
                >
                <div class="analysis-content orange-txt" v-show="showAnalyContents[ite.curIndex]"><h4>解析：</h4>{{ite.quAnalyse}}</div>
                </transition>
              </div>
            </a-checkbox-group>
            <!-- ite.quType===4 写作体 -->
            <div class="input-box" v-if="ite.quType===4">
              <a-textarea
                v-model="userAnswers[ite.curIndex]"
                placeholder="请输入答案！"
                :auto-size="{ minRows: 6, maxRows: 10 }"
                :disabled="showAnalysis"
              />
              <div v-if="showAnalysis" class="analysis">
                <span
                  @click="setShowSysAnswerContents(ite.curIndex)"
                  class="green-txt"
                >
                  参考答案
                </span>
                <span
                  @click="setShowAnalyContents(ite.curIndex)"
                  class="orange-txt"
                >
                  查看解析
                </span>
                <transition
                  enter-active-class="animated fadeIn"
                  leave-active-class="animated fadeOut"
                >
                <div class="analysis-content green-txt" v-show="showSysAnswersContents[ite.curIndex]"><h4>参考答案：</h4>{{ite.answer}}</div>
                </transition>
                <transition
                  enter-active-class="animated fadeIn"
                  leave-active-class="animated fadeOut"
                >
                <div class="analysis-content orange-txt" v-show="showAnalyContents[ite.curIndex]"><h4>解析：</h4>{{ite.quAnalyse}}</div>
                </transition>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p style="text-align: center">
        <a-button type="primary"
        :loading="submitLoading"
        :disabled="disabled"
        @click="showAnalysis?redoPractice():submitAnswer()">{{showAnalysis?"重做":"提交"}}</a-button>
      </p>
    </div>
    <a-modal v-model="visibles"
      width="1000px"
      title=""
      :footer="null"
    >
      <div style="text-align: center" v-if="title===''">
        <img src="imgs/submitsuccess.png" style="width:60%;margin-bottom:30px"/>
        <p><a-button class="btn green-btn" @click="redoPractice">重新答题</a-button></p>
        <p><a-button class="btn orange-btn" @click="viewAnalysis">查看解析</a-button></p>
      </div>
      <div v-if="title==='答题记录'">
        <h3 class="record-title">{{title}}</h3>
        <div class="record">
          <div class="times"
            v-for="(item,index) in userDoList"
            :key="index"
            @click="getUserTestRecords(item.id)"
          >
            <div class="time_sj">
              <a-icon class="colors" type="clock-circle" />
            </div>
            <div class="time_data">{{format.format(item.createDate)}}</div>
            <div class="foot">
              <a-icon type="double-right" />
            </div>
          </div>
        </div>
      </div>
    </a-modal>
    <a-spin class="loading" v-show="loading" />
  </div>
</template>

<script>
import getState from 'utils/getState.js'
import HanIcon from 'components/Icon.vue'
import format from 'utils/format.js'
export default {
  name: 'DoPractice',
  components: { HanIcon },
  data () {
    return {
      loading: false,
      submitLoading: false,
      recordLoading: false,
      userDoList: [], // 答题记录
      visibles: false,
      format,
      showAnalysis: false,
      userAnswers: [],
      exercises: [],
      showAnalyContents: [],
      showSysAnswersContents: [],
      title: '答题记录',
      styleId: 0
    }
  },
  computed: {
    exerciseList () {
      if (
        !this.exercises ||
        !this.exercises.length) return []
      let count = 0
      const userAnswers = []
      const userId = this.$getUserInfo().id
      const res = this.exercises.map((q) => {
        const a = !!q.detailContent && !!q.readContent
        if (a) {
          const newstr = q.readContent.split(q.detailContent).join('<u style="text-decoration-color:red">' + q.detailContent + '</u>')
          q.readContent = newstr
        }
        if (
          !q ||
          !q.studyTestDTOS ||
          !q.studyTestDTOS.length) return []
        const r = q.studyTestDTOS.map((t) => {
          const an = {
            testId: t.id,
            styleId: this.styleId,
            userId: userId,
            quType: t.quType,
            userAnswer: t.userAnswer
          }
          if (t.quType === 2) {
            t.testOptionDTOS = [{
              optionContent: '对',
              isRight: t.answer === '对'
            },
            {
              optionContent: '错',
              isRight: t.answer === '错'
            }]
          }
          // 填空题 下划线处理
          // if (t.quType === 1) {
          //   const reg = /(.)\1_/g
          //   const arr = t.testOptionDTOS.map(t => {
          //     return t.optionContent.match(reg)
          //   })
          //   console.log('arr', arr)
          // }
          userAnswers.push(an)
          t.curIndex = count
          count = count + 1
          return t
        })
        q.studyTestDTOS = r
        return q
      })
      res.userAnswers = userAnswers
      res.len = count
      return res
    },
    disabled () {
      if (this.showAnalysis) return false
      if (this.userAnswers.length < this.exerciseList.len ||
      this.userAnswers.length === 0
      ) return true
      for (let i = 0; i < this.exerciseList.len; i++) {
        if (!this.userAnswers[i]) return true
      }
      return false
    }
  },
  watch: {
    $route () {
      this.doExercises()
      this.showAnalysis = false
      this.userAnswers = []
    },
    visibles (newVal) {
      if (newVal || this.title !== '') return false
      this.showAnalysis = true
    }
  },
  methods: {
    // 返回课文
    goArticle () {
      this.$router.push({ path: `/books/reading-book/${this.$route.params.id}` })
    },
    getAnswerNotes () {
      this.$fetch({
        url: this.$baseUrl + 'ebook/book/getUserAnswerTimeRecord',
        body: {
          pageNum: '1',
          pageSize: '10',
          styleId: this.styleId
        }
      }).loading(
        () => (this.recordLoading = true),
        () => (this.recordLoading = false)
      ).done((res) => {
        // console.log(res)
        this.title = '答题记录'
        this.userDoList = res.resultData.list
        if (this.userDoList == null) {
          this.$message.info('没有答题记录，请先进行答题！')
        } else {
          this.visibles = true
        }
      })
    },
    // 做习题
    doExercises () {
      getState().then((state) => {
        this.styleId = state.styleId
        this.$fetch({
          url: this.$baseUrl + 'ebook/book/getModernTest',
          body: {
            styleId: this.styleId
          }
        }).loading(
          () => (this.loading = true),
          () => (this.loading = false)
        ).done((res) => {
          // console.log('doExercises', res)
          this.exercises = res.resultData
        })
      })
    },
    submitAnswer () {
      const answers = this.exerciseList.userAnswers.map((a, index) => {
        a.userAnswer = this.userAnswers[index].toString()
        return a
      })
      // console.log('answers', answers.toString())
      this.$fetch({
        url: this.$baseUrl + 'ebook/book/batchSaveUserAnswer',
        body: {
          answer: answers
        }
      }).loading(
        () => (this.submitLoading = true),
        () => (this.submitLoading = false)
      ).done((res) => {
        if (res.success) {
          this.saveUserTestStatus()
        } else {
          this.$message.error('提交失败！')
        }
      })
    },
    saveUserTestStatus () {
      this.$fetch({
        url: this.$baseUrl + 'ebook/book/submitUserAnswer',
        body: {
          styleId: this.styleId
        }
      }).loading(
        () => (this.submitLoading = true),
        () => (this.submitLoading = false)
      ).done((res) => {
        if (res.success) {
          this.title = ''
          this.visibles = true
        } else {
          this.$message.error('提交失败！')
        }
      })
    },
    setShowAnalyContents (index) {
      this.showAnalyContents = this.showAnalyContents.map(i => {
        return i
      })
      this.showAnalyContents[index] = !this.showAnalyContents[index]
      // console.log(this.showAnalyContents[index])
    },
    setShowSysAnswerContents (index) {
      this.showSysAnswersContents = this.showSysAnswersContents.map(i => {
        return i
      })
      this.showSysAnswersContents[index] = !this.showSysAnswersContents[index]
      // console.log(this.showSysAnswersContents[index])
    },
    viewAnalysis () {
      this.showAnalysis = true
      this.visibles = false
    },
    redoPractice () {
      this.userAnswers = []
      this.visibles = false
      this.showAnalysis = false
    },
    getUserTestRecords (rid) {
      this.$fetch({
        url: this.$baseUrl + 'ebook/book/getUserTestRecord',
        body: {
          styleId: this.styleId,
          recordId: rid
        }
      }).done(res => {
        this.exercises = res.resultData
        this.userAnswers = this.exerciseList.userAnswers.map(i => {
          if (i.quType === 6) {
            const iu = i.userAnswer.split(',')
            i.userAnswer = iu
          }
          return i.userAnswer
        })
        this.showAnalysis = true
        this.visibles = false
      })
    }
  },
  mounted () {
    this.doExercises()
  }
}
</script>
